export const CLOSE_SIGNAL = 'close';
export const AUDIO_TRACK_SELECTED_SIGNAL = 'audioTrackSelected';
export const SUBTITLES_TRACK_SELECTED_SIGNAL = 'subtitlesTrackSelected';
